import React, { Component } from 'react';
import SearchBox from '../components/SearchBox';
import { Link } from 'react-router';
import { Container, Menu, Image, Icon } from 'semantic-ui-react';

import logo from '../nynex_logo.PNG';
import './MainLayout.css';

class MainLayout extends Component {

  constructor() {
    super();
    this.onSearchChange = this.onSearchChange.bind(this);
  }

  componentDidMount() {
    this.setState({searchKeyword: ""});
  }

  onSearchChange(event) {
    this.setState({searchKeyword: event.target.value});
  }

  render() {
    return (
     <div>
       <div id="menu">
        <Menu fluid size="tiny">
          <Menu.Item>
            <Image src={logo} size="mini" as="a" href="/"/> 
          </Menu.Item>
          <Menu.Item
            name='home'
          >
            <Link to="/">
              <Icon name='home' />
              Home
            </Link>
          </Menu.Item>
          <Menu.Item
            name='calculator'
          >
            <Link to='/calculator'>Price Calculator</Link>
          </Menu.Item>
          
          {/* <Menu.Item
            name='newCalculator'>
            <Link to='/newCalculator'>New Price Calculator</Link>
            </Menu.Item> */}
          <Menu.Item
            position='right'
            name='settings'
          >
            <Link to="/settings">Settings</Link>
          </Menu.Item>
          <Menu.Item position='right'>
            <SearchBox/>
          </Menu.Item>
        </Menu>
      </div>
      <Container>    
        {this.props.children}
      </Container>
    </div>
    )
  }
}
export default MainLayout;



// WEBPACK FOOTER //
// ./src/views/MainLayout.js